import { render, staticRenderFns } from "./Welcome2.vue?vue&type=template&id=247923b6&scoped=true"
import script from "./Welcome2.vue?vue&type=script&lang=js"
export * from "./Welcome2.vue?vue&type=script&lang=js"
import style0 from "./Welcome2.vue?vue&type=style&index=0&id=247923b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247923b6",
  null
  
)

export default component.exports